import(/* webpackMode: "eager", webpackExports: ["EventManagementHeader"] */ "/vercel/path0/src/app/beta/events/[eventSlug]/_components/EventHeaders.tsx");
